import React, { forwardRef } from "react";

import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { Appearance, Stripe, StripeElements } from "@stripe/stripe-js";

import { StripeSettings } from "common/constants";
import { defaultAppearance, appearanceA, appearanceB } from "./appearance";

type BaseComponent = React.ComponentType<any>;
type InjectedProps = { stripe: Stripe, elements: StripeElements };
type WrapperProps<T extends BaseComponent> = Omit<React.ComponentProps<T>, keyof InjectedProps> & Partial<InjectedProps>;

export interface WithElementsOptions {
    appearance?: Appearance;
    appearanceVariant?: "A" | "B";
}

export default function WithElements<T extends BaseComponent>(Component: T, options?: WithElementsOptions) {
    return forwardRef<T, WrapperProps<T>>(function ComponentWithElements(props, ref) {
        if (!props.stripe) {
            throw new Error("stripe prop is required");
        }

        return (
            <Elements
                stripe={props.stripe}
                options={{
                    mode: "setup",
                    paymentMethodCreation: "manual",
                    paymentMethodTypes: StripeSettings.SupportedPaymentMethods,
                    fonts: [{ cssSrc: "https://fonts.googleapis.com/css?family=Source+Sans+Pro&display=swap" }],
                    appearance: options?.appearance ?? (
                        options?.appearanceVariant === "A" ? appearanceA : options?.appearanceVariant === "B" ? appearanceB : defaultAppearance
                    )
                }}
            >
                <ElementsConsumer>
                    {({ stripe, elements }) => (
                        // @ts-ignore
                        <Component {...props} stripe={stripe} elements={elements} ref={ref} />
                    )}
                </ElementsConsumer>
            </Elements>
        );
    });
}
